import { render, staticRenderFns } from "./UITable.vue?vue&type=template&id=f657acb0"
import script from "./UITable.vue?vue&type=script&lang=js"
export * from "./UITable.vue?vue&type=script&lang=js"
import style0 from "./UITable.vue?vue&type=style&index=0&id=f657acb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports